module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACgAAAAUCAYAAAD/Rn+7AAAAQ0lEQVR42u3OQREAIAwDwdQGmlCFAP5YQEg14CZI4FtmbhVsWLIKI0iQ4ENM9SwdlLYJEiT4c/CMlqWDXjJBggQ/Dl7UPSljkX8YPQAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./client/src/images/flags/am.png
// module id = 767
// module chunks = 0